import { computed, Injectable, signal } from "@angular/core";
import { DashboardFulfillmentFunnelResponse } from "../Dto/DashboardFulfillmentFunnelResponse";
import { DashboardOverviewResponse, DashboardPeriod } from "../Dto/DashboardOverviewResponse";
import { DashboardStateModel } from "../Dto/DashboardStateModel";

const initialState: DashboardStateModel = {
  overview: null,
  fulfillmentFunnel: null,
  selectedPeriod: "ytd",
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class DashboardState {
  private readonly state = signal<DashboardStateModel>(initialState);

  readonly overview = computed(() => this.state().overview);
  readonly fulfillmentFunnel = computed(() => this.state().fulfillmentFunnel);
  readonly fulfillmentFunnelStages = computed(() => this.state().fulfillmentFunnel?.stages ?? []);
  readonly selectedPeriod = computed(() => this.state().selectedPeriod);
  readonly cards = computed(() => this.state().overview?.cards ?? []);
  readonly loading = computed(() => this.state().loading);
  readonly error = computed(() => this.state().error);

  setOverview(overview: DashboardOverviewResponse): void {
    this.state.update((state) => ({
      ...state,
      overview,
      selectedPeriod: overview.period,
      error: null,
    }));
  }

  setFulfillmentFunnel(fulfillmentFunnel: DashboardFulfillmentFunnelResponse): void {
    this.state.update((state) => ({
      ...state,
      fulfillmentFunnel,
      selectedPeriod: fulfillmentFunnel.period,
      error: null,
    }));
  }

  setSelectedPeriod(selectedPeriod: DashboardPeriod): void {
    this.state.update((state) => ({ ...state, selectedPeriod }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }
}
